import { Cell } from "@tanstack/react-table";

import "ui/data-grid/data-grid.types";

export const splitCellsByPin = <T>(cells: Cell<T, unknown>[]) => ({
  leftCells: cells.filter((cell) => !cell.column.columnDef.meta?.isPinnedRight),
  rightCells: cells.filter((cell) => cell.column.columnDef.meta?.isPinnedRight),
});
